import React, { useState, useCallback } from 'react';
import { ArrowRight } from 'lucide-react';
import { Card, Valuat } from 'xland-ui';
import { useSelector } from 'react-redux';
import PopupEditOrganization from '../routes/InvestorOrganizations/PopupEditOrganization';
import PopupEditInvestment from '../PopupEditInvestment';

export const CREATE_ORGANIZATION = 'createOrganization';
export const ADD_INVESTMENT = 'addInvestment';
export const REQUEST_DEMO = 'requestDemo';

function EmptyInvestments() {
  const literals = useSelector(state => state.i18n.literals.investmentAssets);
  const organizations = useSelector(state => state.session.user.organizations);
  const [showOrganizationPopup, setShowOrganizationPopup] = useState(false);
  const [showInvestmentPopup, setShowInvestmentPopup] = useState(false);

  const FEATURES = [
    { id: CREATE_ORGANIZATION, action: 'openOrganizationPopup' },
    { id: ADD_INVESTMENT, action: 'openInvestmentPopup' },
    { id: REQUEST_DEMO, action: 'requestDemo' },
  ];

  const handleRequestDemo = useCallback((e) => {
    e?.preventDefault();
    e?.stopPropagation();
    window.zE?.('messenger', 'open');
  }, []);

  const handleAction = useCallback((action, e) => {
    const actions = {
      openOrganizationPopup: () => setShowOrganizationPopup(true),
      openInvestmentPopup: () => organizations.length && setShowInvestmentPopup(true),
      requestDemo: () => handleRequestDemo(e),
    };
    actions[action]?.();
  }, [handleRequestDemo, organizations]);

  const renderFeatureCard = useCallback(({ id, action }) => (
    <div
      key={id}
      className='box box-padding'
      onClick={e => handleAction(action, e)}
      role='button'
      tabIndex={0}
    >
      <h6 className='fw-b'>{literals[id]}</h6>
      <span>{literals[`${id}Description`]}</span>
    </div>
  ), [literals, handleAction]);

  const renderFeatureAction = useCallback(({ id, action }) => (
    <li
      key={id}
      onClick={(e) => handleAction(action, e)}
      role='button'
      tabIndex={0}
      className={`${action === 'openInvestmentPopup' && !organizations.length && 'disabled'}`}
    >
      <div className='d-flex align-items-center'>
        <span>{literals[id]}</span>
      </div>
      <ArrowRight />
    </li>
  ), [literals, handleAction, organizations]);

  return (
    <>
      <Card className='mb-sp p-5'>
        <div className='setup-captable'>
          <div className='setup-captable--message'>
            <h3 className='fw-b'>{literals.setupCaptable}</h3>
            <div className='valuat-logo'><Valuat /></div>
            <div>{literals.chooseOption}</div>
          </div>
          <ul className='setup-captable--actions'>
            {FEATURES.map(renderFeatureAction)}
          </ul>
        </div>
      </Card>

      <div className='captable-features'>
        {FEATURES.map(renderFeatureCard)}
      </div>

      {showOrganizationPopup && (
        <PopupEditOrganization onClose={() => setShowOrganizationPopup(false)} />
      )}

      {showInvestmentPopup && (
        <PopupEditInvestment
          onClose={() => setShowInvestmentPopup(false)}
        />
      )}
    </>
  );
}

export default EmptyInvestments;
